import { gql } from '@apollo/client';

export const fetchOverdueInvoicesForTransactionAccount = gql`
  query fetchOverdueInvoicesForTransactionAccount($id: ID!, $searchOptions: ConnectionSearchOptions) {
    transactionAccount(id: $id) {
      id
      overdueInvoices(searchOptions: $searchOptions) {
        totalCount
        nodes {
          id
          invoiceNumber
          sourceSystem
          creditCard {
            last4Numbers
          }
          invoiceDueDays
          paymentMethod
          dueDate
          createdDate: createdTimestamp
          grandTotal: total
          paymentCurrency
          pdfLink
          refunds {
            id
            type
            createdDate
            creditNoteNumber
            sourceSystem
            total
            currency
            status
            arn
          }
          status
          dunningStatus {
            errorCode
          }
          shipTo {
            address {
              address1
              address2
              city
              state
              country
              postalCode
            }
          }
          purchaseOrderNumber
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;
